/**
 * Pagination Mobile Trim
 *
 * On mobile (<=768px), trims pagination to show only the active page
 * and its immediate neighbors (3 pages max). Runs on load, resize,
 * and DOM mutations (for AJAX pagination).
 */

const MOBILE_BP = 768;
const VISIBLE_NEIGHBORS = 1; // Show 1 page on each side of active

function trimPagination() {
	var isMobile = window.innerWidth <= MOBILE_BP;
	var pagesContainers = document.querySelectorAll(
		'[class*="-pagination__pages"], [class*="-pagination__pages"]'
	);

	pagesContainers.forEach(function (container) {
		var children = Array.from(container.children);
		if (!isMobile) {
			// Desktop/tablet: show everything
			children.forEach(function (el) {
				el.style.display = '';
			});
			return;
		}

		// Find active page index among page/ellipsis elements
		var activeIndex = -1;
		children.forEach(function (el, i) {
			if (el.classList.contains('is-active') || el.getAttribute('aria-current') === 'page') {
				activeIndex = i;
			}
		});

		if (activeIndex === -1) {
			// No active page found — show first 3
			children.forEach(function (el, i) {
				el.style.display = i < 3 ? '' : 'none';
			});
			return;
		}

		// Build list of indices to show: active + neighbors
		// But we need to count only page elements (not ellipsis)
		var pageIndices = [];
		children.forEach(function (el, i) {
			if (!el.classList.toString().match(/ellipsis/)) {
				pageIndices.push(i);
			}
		});

		var activePagePos = pageIndices.indexOf(activeIndex);
		var startPos = Math.max(0, activePagePos - VISIBLE_NEIGHBORS);
		var endPos = Math.min(pageIndices.length - 1, activePagePos + VISIBLE_NEIGHBORS);

		// Ensure we always show 3 pages if available
		if (endPos - startPos < 2 && pageIndices.length >= 3) {
			if (startPos === 0) {
				endPos = Math.min(2, pageIndices.length - 1);
			} else if (endPos === pageIndices.length - 1) {
				startPos = Math.max(0, pageIndices.length - 3);
			}
		}

		var visibleIndices = [];
		for (var p = startPos; p <= endPos; p++) {
			visibleIndices.push(pageIndices[p]);
		}

		children.forEach(function (el, i) {
			el.style.display = visibleIndices.indexOf(i) !== -1 ? '' : 'none';
		});
	});
}

module.exports = function PaginationMobileTrim() {
	trimPagination();
	window.addEventListener('resize', trimPagination);

	// Watch for AJAX pagination updates
	var observer = new MutationObserver(trimPagination);
	document.querySelectorAll('[data-post-list]').forEach(function (el) {
		observer.observe(el, { childList: true, subtree: true });
	});
};
